import { DatePipe } from '@angular/common';
import {ICompaniesShortList, IMarketCompanyRatesByLotNumberWithCompanyId, IParkerImportErrors,  IParkerProfileQueuedForImport} from 'src/app/shared/interfaces';
import { getParkerMaxEndDateDisplay, isParkerEndDateBeyondMax } from 'src/app/shared/code/parker-date-rules';

export class ParkerImportValidation {
    public validationErrors: IParkerImportErrors[] = [];
    
    constructor(
            private unvalidatedParkerProfiles: IParkerProfileQueuedForImport[],
            private companyList: ICompaniesShortList[],
            private marketCompanyRatesForLotNumber: IMarketCompanyRatesByLotNumberWithCompanyId[],
    ) {
        
    }


    ValidateParkerProfiles(parkerData: IParkerProfileQueuedForImport[]): IParkerImportErrors[]{
        let ii: number;

        for(ii = 0; ii < parkerData.length; ii++){
            let currentParker: IParkerProfileQueuedForImport = parkerData[ii];

            this.RunValidationTests(currentParker, ii);
        }
        // 
        return this.validationErrors;

    }

    private RunValidationTests(parkerProfile: IParkerProfileQueuedForImport, rowNumber: number): void{
        
        this.IsCompanyNameValid(parkerProfile.companyName, rowNumber);
        this.IsFirstNameValid(parkerProfile.firstName, rowNumber);
        this.IsLastNameValid(parkerProfile.lastName, rowNumber);
        this.IsParkerPayTypeValid(parkerProfile.parkerPayType, rowNumber);
        this.IsInvoiceDeliveryMethodValid(parkerProfile.deliveryType, rowNumber);
        this.IsStartDateValid(parkerProfile.startDate, rowNumber);
        this.IsEndDateValid(parkerProfile.startDate, parkerProfile.endDate, rowNumber);
        this.IsRateNumberValid(parkerProfile.rateNumber, parkerProfile.companyName, rowNumber);
        this.IsCardNumberValid(+parkerProfile.cardNumber, rowNumber);

    }

    private IsEndDateValid(startDate: Date, endDate: Date, rowNumber: number):void{
        let anError: IParkerImportErrors = {} as IParkerImportErrors;
        let ii: number = 0;

        if(endDate == null)
            return;

        if(endDate.toLocaleString().trim() == ''){
             return;
        }  

        // Checked ahead of the start date guards below, because the ceiling does not depend on a
        // start date and a row missing one should still be called out.
        if(isParkerEndDateBeyondMax(endDate)){
            anError.rowNumber = rowNumber;
            anError.columnName = 'endDate';
            anError.message = 'The End Date cannot be later than ' + getParkerMaxEndDateDisplay();

            this.validationErrors.push(anError);
            return;
        }

        if(startDate == null)
            return;

        if(startDate.toLocaleString().trim() == ''){
            return;
        }

        let currentStartDate: Date = new Date(startDate);
        let month: number = currentStartDate.getMonth();
        let day:  number = currentStartDate.getDate();
        let year: number = currentStartDate.getFullYear();
        let formattedStartDate: Date = new Date(year, month, day, 0, 0, 0);
    
        let currentEndDate = new Date(endDate);
        month = currentEndDate.getMonth();
        day = currentEndDate.getDate();
        year = currentEndDate.getFullYear();
        let formattedEndDate: Date = new Date(year, month, day, 0, 0, 0);
     

        if(formattedEndDate < formattedStartDate){
            anError.rowNumber = rowNumber;
            anError.columnName = 'endDate';
            anError.message = 'The End Date is required and if entered cannot be prior to the Start Date';

            this.validationErrors.push(anError);
            return;
        }

    }




    private IsRateNumberValid(rateNumber: string, companyName: string, rowNumber: number, ):void{
        let anError: IParkerImportErrors = {} as IParkerImportErrors;
        let ii: number = 0;
        let rateNumberFound: boolean = false;
        
        if(rateNumber.toLocaleString() == ''){
            anError.rowNumber = rowNumber;
            anError.columnName = 'rateNumber';
            anError.message = 'The Rate Number is required and must be a valid Rate Number for the Company';

            this.validationErrors.push(anError);
            return;
        }

        try
        {
            let rateNumberAsInt: number = +rateNumber;

        //todo check if valid rate number for the company name
            for(ii = 0; ii < this.marketCompanyRatesForLotNumber.length; ii++){
                if(this.marketCompanyRatesForLotNumber[ii].companyName.toUpperCase() == companyName.toUpperCase() && rateNumberAsInt == this.marketCompanyRatesForLotNumber[ii].rateNumber)
                    rateNumberFound = true;
            }

            if(!rateNumberFound){
                anError.rowNumber = rowNumber;
                anError.columnName = 'rateNumber';
                anError.message = 'The Rate Number is required and must be a valid Rate Number for the Company';

                this.validationErrors.push(anError);
            }
        
        }
        catch(err){
            anError.rowNumber = rowNumber;
            anError.columnName = 'rateNumber';
            anError.message = 'The Rate Number is required and must be a valid Rate Number for the Company';

            this.validationErrors.push(anError);
        }

    }

    private IsCardNumberValid(cardNumber: number, rowNumber: number):void{
        let anError: IParkerImportErrors = {} as IParkerImportErrors;
        let ii: number = 0;

        if(cardNumber == null)
            return;
        
        let intCardNumber: number;

        try
        {
            intCardNumber = +cardNumber;
        }
        catch(err){
            anError.rowNumber = rowNumber;
            anError.columnName = 'cardNumber';
            anError.message = 'The Card Number must be a number and cannot contain letters or other puncuation characters';

            this.validationErrors.push(anError);
        }

    }


    private IsStartDateValid(startDate: Date, rowNumber: number):void{
        let anError: IParkerImportErrors = {} as IParkerImportErrors;
        let ii: number = 0;



        
        if(startDate.toLocaleString().trim() == ''){
            anError.rowNumber = rowNumber;
            anError.columnName = 'startDate';
            anError.message = 'The Start Date is required, must be a valid date and cannot be more than 60 days from today';

            this.validationErrors.push(anError);
            return;
        }


        try
        {

            //Is a Valid Date
            let newDate = new Date(startDate);
            if(newDate.toLocaleDateString() == 'Invalid Date'){
                anError.rowNumber = rowNumber;
                anError.columnName = 'startDate';
                anError.message = 'The Start Date is required, must be a valid date and cannot be more than 60 days from today';

                this.validationErrors.push(anError);
                return;
            }


            //See if start date is within 60 days of today
            let today: Date = new Date;
            let numberOfDays: number = startDate.valueOf() - today.valueOf();
            numberOfDays = numberOfDays/1000/24/60/60

            if(numberOfDays > 60){
                anError.rowNumber = rowNumber;
                anError.columnName = 'startDate';
                anError.message = 'The Start Date is required, must be a valid date and cannot be more than 60 days from today';

                this.validationErrors.push(anError);
            }
        }
        catch(err){
                console.error('error trying to convert to date' + JSON.stringify(err));
                anError.rowNumber = rowNumber;
                anError.columnName = 'startDate';
                anError.message = 'The Start Date is required, must be a valid date and be within 60 days of today';

                this.validationErrors.push(anError);
            
        }

    }


    private IsInvoiceDeliveryMethodValid(deliveryType: string, rowNumber: number):void{
        let anError: IParkerImportErrors = {} as IParkerImportErrors;
        let ii: number = 0;
        let invoiceDeliveryTypeFlag: boolean = false;
        
        if(deliveryType == ''){
            anError.rowNumber = rowNumber;
            anError.columnName = 'deliveryType';
            anError.message = 'The Invoice Delivery Method is required and must be Email or Print';

            this.validationErrors.push(anError);
            return;
        }

        if(deliveryType.trim().toLocaleLowerCase() != 'email' && deliveryType.trim().toLocaleLowerCase() != 'print'){
            invoiceDeliveryTypeFlag = true;
        }

        if(invoiceDeliveryTypeFlag){
            anError.rowNumber = rowNumber;
            anError.columnName = 'deliveryType';
            anError.message = 'The Invoice Delivery Method is required and must be Email or Print';

            this.validationErrors.push(anError);
        }

    }



    private IsParkerPayTypeValid(parkerPayType: string, rowNumber: number):void{
        let anError: IParkerImportErrors = {} as IParkerImportErrors;
        let ii: number = 0;
        let invalidParkerPayTypeFlagValid: boolean = false;
        
        if(parkerPayType == ''){
            anError.rowNumber = rowNumber;
            anError.columnName = 'parkerPayType';
            anError.message = 'Parker Pay Type is required and must be Parker or Company';

            this.validationErrors.push(anError);
            return;
        }

        if(parkerPayType.trim().toLocaleLowerCase() != 'parker' && parkerPayType.trim().toLocaleLowerCase() != 'company'){
            invalidParkerPayTypeFlagValid = true;
        }

        if(invalidParkerPayTypeFlagValid){
            anError.rowNumber = rowNumber;
            anError.columnName = 'parkerPayType';
            anError.message = 'Parker Pay Type is required and must be Parker or Company';

            this.validationErrors.push(anError);
        }

    }


    private IsLastNameValid(lastName: string, rowNumber: number):void{
        let anError: IParkerImportErrors = {} as IParkerImportErrors;
        let ii: number = 0;
        
        if(lastName == ''){
            anError.rowNumber = rowNumber;
            anError.columnName = 'lastName';
            anError.message = 'The Last Name is required';

            this.validationErrors.push(anError);
            return;
        }

    }


    private IsFirstNameValid(firstName: string, rowNumber: number):void{
        let anError: IParkerImportErrors = {} as IParkerImportErrors;
        let ii: number = 0;
        
        if(firstName == ''){
            anError.rowNumber = rowNumber;
            anError.columnName = 'firstName';
            anError.message = 'The First Name is required';

            this.validationErrors.push(anError);
            return;
        }

    }



    private IsCompanyNameValid(companyName: string, rowNumber: number):void{
        let anError: IParkerImportErrors = {} as IParkerImportErrors;
        let ii: number = 0;
        let companyNameValid: boolean = false;

        if(companyName == ''){
            anError.rowNumber = rowNumber;
            anError.columnName = 'companyName';
            anError.message = 'Company Name cannot be blank or is Invalid';

            this.validationErrors.push(anError);
            return;
        }


        //check to see if the company name is a valid company
        for(ii = 0; ii < this.companyList.length; ii++){
            if(companyName.trim().toLocaleUpperCase() == this.companyList[ii].companyName.trim().toLocaleUpperCase())
            {
                companyNameValid = true;
            }
        }


        if(!companyNameValid){
            anError.rowNumber = rowNumber;
            anError.columnName = 'companyName';
            anError.message = 'Company Name cannot be blank or is Invalid';

            this.validationErrors.push(anError);
        }

    }



   

}